// Double S : le menu du haut s'ouvre au clic (et non plus au survol).
// Le fonctionnement d'origine du thème est dans header-menu-base.js.
import './header-menu-base.js';

(function () {
  if (window.__dsMenuClick) return;
  window.__dsMenuClick = true;

  function inMenu(el) {
    return el instanceof Element && el.closest('header-menu');
  }

  // 1. Ignorer le survol : on bloque pointerenter / pointerleave avant qu'ils
  //    n'atteignent les éléments du menu.
  ['pointerenter', 'pointerleave'].forEach(function (type) {
    document.addEventListener(
      type,
      function (e) {
        var path = e.composedPath ? e.composedPath() : [];
        for (var i = 0; i < path.length; i++) {
          if (path[i] instanceof Element && path[i].tagName === 'HEADER-MENU') {
            e.stopImmediatePropagation();
            return;
          }
        }
      },
      true
    );
  });

  // 2. Clic sur « Nouveautés », « Homme », « Femme »… : ouvre / ferme le sous-menu
  //    au lieu d'aller directement sur la page.
  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!(target instanceof Element)) return;
      var link = target.closest('.menu-list__trigger > .menu-list__link');
      if (!link || !inMenu(link)) return;
      var button = link.parentElement.querySelector('.menu-list__disclosure');
      if (!button) return;
      e.preventDefault();
      e.stopPropagation();
      button.click();
    },
    true
  );

  // 3. Clic ailleurs sur la page : ferme le sous-menu ouvert.
  document.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      if (path[i] instanceof Element && path[i].tagName === 'HEADER-MENU') return;
    }
    // « Plus » ouvert : on ferme via son bouton ; sinon via la flèche du sous-menu ouvert.
    var open =
      document.querySelector('header-menu [slot="more"] [aria-expanded="true"]') ||
      document.querySelector('header-menu .menu-list__disclosure[aria-expanded="true"]');
    if (open) open.click();
  });
})();
